import { FC, useState } from 'react';
import { OwnBlock } from '~/shared/ui/OwnBlock/OwnBlock';
import { Button } from '~/shared/ui/Button/Button';
//import Question from '../../../../../public/icons/question.svg?react';
import Inter from '../../../../../public/icons/entry.svg?react';
import { cvaIcon } from '~/shared/styles/IconStyles';
import { cvaRentBegin } from '~/pages/HourlyRent/RentBegin/ui/RentBeginStyles';
import { ActiveRent } from '~/shared/API/response-types/rent-types';
import { priceFormatter } from '~/shared/utils/priceFormatter';
import { Payment } from '~/widgets/Payment/ui/Payment';
import { Portal } from '~/shared/ui/Portal/Portal';
import { useFinishRentSession } from '~/shared/hooks/useFinishSession';

interface Props {
  rent: ActiveRent;
  onPay: () => void;
  onExit: () => void;
  onMainPage?: boolean;
  pastRent?: boolean;
}

export const RentBegin: FC<Props> = ({ onMainPage, rent }) => {
  const [openPayment, setOpenPayment] = useState(false);
  const { finish, isLoading } = useFinishRentSession(() => {});

  const getTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const mDisplay = m > 9 ? m : '0' + m;

    return h + ':' + mDisplay;
  };

  return rent ? (
    <>
      <div className={cvaRentBegin({ absolute: onMainPage })}>
        {rent.status == 'in_progress' ? (
          <OwnBlock className={'flex flex-col'} variant={'big'} shadow>
            <div className={'flex mb-0.4 justify-between'}>
              <h2 className={'text-header-s'}>
                {getTime(rent.seconds)} · {priceFormatter(rent.receipt.total)}
              </h2>
              {/* <Question className={cvaIcon({ iconSize: 'secondary' })} /> */}
            </div>
            <p className={'text-m-sb text-cGray mb-1.2'}>
              <span>{rent.parking_space.parking.name}</span> ·{' '}
              <span>{rent.parking_space.parking.address}</span>
            </p>

            {rent.receipt.total > 0 && (
              <Button
                size={'common'}
                variant={'primary'}
                onClick={() => setOpenPayment(true)}>
                Оплатить
              </Button>
            )}
            <p className={'text-m-sb text-cGray mt-1.2 pr-3'}>
              {rent.receipt.total > 0
                ? 'Выехать можно после оплаты'
                : 'Бесплатный период пребывания на парковке - для завершения сессии можно просто подъехать к выезду'}
            </p>
          </OwnBlock>
        ) : rent.status == 'payed' ? (
          <OwnBlock className={'flex flex-col'} variant={'big'} shadow>
            <div className={'flex mb-0.4 justify-between'}>
              <h2 className={'text-header-s'}>15 минут на выезд</h2>
            </div>
            <p className={'text-m-sb text-cGray mb-1.2'}>
              <span>{rent.parking_space.parking.name}</span> ·{' '}
              <span>{rent.parking_space.parking.address}</span>
            </p>
            <Button
              isLoading={isLoading}
              size={'common'}
              variant={'primary'}
              icon={<Inter className={cvaIcon({ iconSize: 'secondary' })} />}
              onClick={async () => {
                finish(rent.id);
              }}>
              Открыть выезд
            </Button>
          </OwnBlock>
        ) : rent.status == 'completed' ? (
          <OwnBlock className={'flex flex-col'} variant={'big'} shadow>
            <div
              className={'flex mb-0.4 justify-between'}
              onClick={() => setOpenPayment(true)}>
              <h2 className={'text-header-s'}>
                {getTime(rent.seconds)} ·{' '}
                {rent?.receipt?.total
                  ? priceFormatter(rent.receipt.total)
                  : null}
              </h2>
              {/* <Question className={cvaIcon({ iconSize: 'secondary' })} /> */}
            </div>
            <p className={'text-m-sb text-cGray mb-1.2'}>
              <span>{rent.parking_space.parking?.name}</span> ·{' '}
              <span>{rent.parking_space.parking?.address}</span>
            </p>
          </OwnBlock>
        ) : null}
      </div>
      {openPayment && (
        <Portal>
          <Payment
            hourly
            rent={rent}
            title={'Оплата парковки'}
            onPay={() => {
              setOpenPayment(false);
            }}
            onClose={() => {
              setOpenPayment(false);
            }}
          />
        </Portal>
      )}
    </>
  ) : null;
};
